export default "__VITE_ASSET__Fe3Co7q5__"